<div class="row action-toolbar" style="margin-top: 20px">
    <div class="col-12">
        <form class="form-inline">
            <div class="input-header-group">
                <span class="input-header">Start Year</span>
                <wj-combo-box
                    [(ngModel)]="startYear"
                    name="overheadStartYear"
                    (ngModelChange)="onRangeChanged()"
                    [itemsSource]="yearOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    style="width: 110px"
                ></wj-combo-box>
            </div>

            <div class="input-header-group">
                <span class="input-header">End Year</span>
                <wj-combo-box
                    [(ngModel)]="endYear"
                    name="overheadEndYear"
                    (ngModelChange)="onRangeChanged()"
                    [itemsSource]="yearOptions"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    style="width: 110px"
                ></wj-combo-box>
            </div>
        </form>
    </div>
</div>

@if (rangeInvalid) {
    <p class="text-danger mt-2">Start year must be on or before the end year.</p>
}
@if (loadError) {
    <p class="text-danger mt-2">{{ loadError }}</p>
}

<p class="text-muted mt-3 mb-2">
    Field operating overhead is overhead cost divided by earned revenue from closed WIP months. One percentage for the year, with the four cost groups underneath.
    Costs are the net general ledger detail for the month, plus field labor on phase 100.17, cost type 10. GL 8010 estimating labor is included with labor, not with the other estimating accounts.
    A year-end closing entry posted to these accounts is included in that month.
    @if (closedLabel) {
        Closed through {{ closedLabel }}.
    }
</p>

@if (latestYear) {
    <div class="row mt-2">
        <div class="col-md-6">
            <div class="card">
                <div class="card-body">
                    <div class="text-muted">{{ latestYear.label }}@if (closedLabel && latestYear.isYearToDate) { through {{ closedLabel }} }</div>
                    <strong>{{ latestYear.totalPercent == null ? '—' : (latestYear.totalPercent | percent: '1.2-2') }}</strong>
                    <div class="text-muted small">
                        {{ latestYear.totalCost | currency: 'USD' : 'symbol' : '1.0-0' }} / {{ latestYear.revenue | currency: 'USD' : 'symbol' : '1.0-0' }}
                    </div>
                    <div class="small mt-2">
                        Labor {{ latestYear.laborPercent == null ? '—' : (latestYear.laborPercent | percent: '1.1-1') }}
                        · Labor related {{ latestYear.laborRelatedPercent == null ? '—' : (latestYear.laborRelatedPercent | percent: '1.1-1') }}
                        · Other {{ latestYear.otherPercent == null ? '—' : (latestYear.otherPercent | percent: '1.1-1') }}
                        · Estimating {{ latestYear.estimatingPercent == null ? '—' : (latestYear.estimatingPercent | percent: '1.1-1') }}
                    </div>
                </div>
            </div>
        </div>
        @if (priorYear) {
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body">
                        <div class="text-muted">{{ priorYear.label }}</div>
                        <strong>{{ priorYear.totalPercent == null ? '—' : (priorYear.totalPercent | percent: '1.2-2') }}</strong>
                        <div class="text-muted small">
                            {{ priorYear.totalCost | currency: 'USD' : 'symbol' : '1.0-0' }} / {{ priorYear.revenue | currency: 'USD' : 'symbol' : '1.0-0' }}
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}

<wj-flex-chart
    style="height: 280px"
    class="mt-3"
    [itemsSource]="chartPoints"
    [bindingX]="'year'"
    [chartType]="'Line'"
    [header]="'Field Operating Overhead'"
    [legendToggle]="true"
>
    <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Percent of revenue'" [format]="'p1'"></wj-flex-chart-axis>
    @for (series of chartSeries; track series.binding) {
        <wj-flex-chart-series [binding]="series.binding" [name]="series.name"></wj-flex-chart-series>
    }
</wj-flex-chart>

<div class="row mt-3">
    <div class="col-xl-7">
        <h5 class="mb-1">By year</h5>
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="yearGrid"></action-toolbar-count>
                    <grid-export [grid]="yearRateGrid" [name]="'Overhead by Year'"></grid-export>
                </form>
            </div>
        </div>
        <wj-flex-grid
            #yearRateGrid
            style="height: 220px"
            [isReadOnly]="true"
            (initialized)="yearGrid.initialize(yearRateGrid)"
            (destroy)="yearGrid.destroy()"
            [itemsSource]="yearGrid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Year'" [binding]="'label'" [width]="110"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Revenue'" [binding]="'revenue'" [width]="130" [format]="'c0'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Total'" [binding]="'totalPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Labor'" [binding]="'laborPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Labor Related'" [binding]="'laborRelatedPercent'" [width]="130" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Other'" [binding]="'otherPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Estimating'" [binding]="'estimatingPercent'" [width]="110" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Total Cost'" [binding]="'totalCost'" [width]="130" [format]="'c0'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
    <div class="col-xl-5">
        <h5 class="mb-1">Labor breakdown{{ selectedYear ? ' — ' + selectedYear.label : '' }}</h5>
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <grid-export [grid]="laborRateGrid" [name]="'FOO Labor Breakdown'"></grid-export>
                </form>
            </div>
        </div>
        <wj-flex-grid
            #laborRateGrid
            style="height: 220px"
            [isReadOnly]="true"
            (initialized)="laborGrid.initialize(laborRateGrid)"
            (destroy)="laborGrid.destroy()"
            [itemsSource]="laborGrid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Labor'" [binding]="'label'" [width]="280"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Cost'" [binding]="'cost'" [width]="120" [format]="'c0'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'% of Revenue'" [binding]="'percent'" [width]="120" [format]="'p2'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>
<div class="row mt-3">
    <div class="col-12">
        <h5 class="mb-1">By month{{ selectedYear ? ' — ' + selectedYear.label : '' }}</h5>
        <wj-flex-grid
            #monthRateGrid
            style="height: 220px"
            [isReadOnly]="true"
            (initialized)="monthGrid.initialize(monthRateGrid)"
            (destroy)="monthGrid.destroy()"
            [itemsSource]="monthGrid.view"
        >
            <wj-flex-grid-filter></wj-flex-grid-filter>
            <wj-flex-grid-column [header]="'Month'" [binding]="'label'" [width]="120"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Revenue'" [binding]="'revenue'" [width]="130" [format]="'c0'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Total'" [binding]="'totalPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Labor'" [binding]="'laborPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Labor Related'" [binding]="'laborRelatedPercent'" [width]="130" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Other'" [binding]="'otherPercent'" [width]="90" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Estimating'" [binding]="'estimatingPercent'" [width]="110" [format]="'p2'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Total Cost'" [binding]="'totalCost'" [width]="130" [format]="'c0'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>
</div>

<h5 class="mt-3 mb-1">Accounts{{ selectedMonth ? ' — ' + selectedMonth.label : '' }}</h5>
<wj-flex-grid
    #accountGridRef
    style="height: 280px"
    [isReadOnly]="true"
    (initialized)="accountGrid.initialize(accountGridRef)"
    (destroy)="accountGrid.destroy()"
    [itemsSource]="accountGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Category'" [binding]="'category'" [width]="150"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Account'" [binding]="'account'" [width]="140"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="280"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Amount'" [binding]="'amount'" [width]="140" [format]="'c2'"></wj-flex-grid-column>
</wj-flex-grid>
<grid-selection-calculation [grid]="accountGridRef"></grid-selection-calculation>

<h5 class="mt-4 mb-1">Accounts in the overhead range that are not in the formula</h5>
<div class="row action-toolbar">
    <div class="col-12">
        <form class="form-inline">
            <grid-export [grid]="validationGridRef" [name]="'Unmapped Overhead Accounts'"></grid-export>
        </form>
    </div>
</div>
@if (unmappedCount > 0) {
    <div class="alert alert-warning">
        {{ unmappedCount }} GL account{{ unmappedCount === 1 ? '' : 's' }} between 7150-7188 or 7200-8099 had activity and are not included in the overhead rate.
    </div>
} @else {
    <p class="text-muted">No unmapped accounts with a balance in this range.</p>
}
<wj-flex-grid
    #validationGridRef
    style="height: 260px"
    [isReadOnly]="true"
    (initialized)="validationGrid.initialize(validationGridRef)"
    (destroy)="validationGrid.destroy()"
    [itemsSource]="validationGrid.view"
>
    <wj-flex-grid-filter></wj-flex-grid-filter>
    <wj-flex-grid-column [header]="'Account'" [binding]="'account'" [width]="140"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="280"></wj-flex-grid-column>
    <wj-flex-grid-column [header]="'Total'" [binding]="'total'" [width]="140" [format]="'c2'"></wj-flex-grid-column>
    @for (year of years; track year) {
        <wj-flex-grid-column [header]="'' + year" [binding]="'amount' + year" [width]="130" [format]="'c2'"></wj-flex-grid-column>
    }
</wj-flex-grid>
